/* ====== HEADER (mobile toggle) ====== */
(function(){
  function bindHeader(sectionId){
    var root=document.getElementById('ng-header-'+sectionId);
    if(!root) return;
    var btn=root.querySelector('[data-ng-toggle]');
    var menu=root.querySelector('[data-ng-menu]');
    if(!btn||!menu) return;
    btn.addEventListener('click', function(){
      var exp=btn.getAttribute('aria-expanded')==='true';
      btn.setAttribute('aria-expanded', !exp);
      menu.hidden=exp;
    });
  }
  document.querySelectorAll('[data-ng-header]').forEach(function(el){
    bindHeader(el.getAttribute('data-ng-header'));
  });
})();

/* ====== REVEAL ON SCROLL (оба синтаксиса) ====== */
(function(){
  function initReveal(){
    var a = document.querySelectorAll('[data-animate]');
    var b = document.querySelectorAll('.ng-anim');
    if(!a.length && !b.length) return;

    // Фолбэк без IO
    if(!('IntersectionObserver' in window)){
      a.forEach(function(el){ el.classList.add('is-inview'); });
      b.forEach(function(el){ el.classList.add('ng-inview'); });
      return;
    }

    // Вариант A: [data-animate] -> .is-inview
    var ioA = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('is-inview');
          ioA.unobserve(en.target);
        }
      });
    },{ threshold:0.1, rootMargin:'0px 0px -10% 0px' });
    a.forEach(function(el){ ioA.observe(el); });

    // Вариант B: .ng-anim -> .ng-inview (+ поддержка --ng-delay в CSS)
    var ioB = new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        if(en.isIntersecting){
          en.target.classList.add('ng-inview');
          ioB.unobserve(en.target);
        }
      });
    },{ threshold:0.2 });
    b.forEach(function(el){ ioB.observe(el); });
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', initReveal); }
  else { initReveal(); }

  // Переинициализация в редакторе
  document.addEventListener('shopify:section:load', initReveal);
})();

/* ====== LUCIDE (иконки) ====== */
(function(){
  function draw(){ if(window.lucide){ try{ window.lucide.createIcons(); }catch(e){} } }
  window.addEventListener('load', draw);
  document.addEventListener('shopify:section:load', draw);
})();

/* ====== TESTIMONIALS SLIDER ====== */
(function(){
  function initTestimonials(root){
    if(!root) return;
    var track = root.querySelector('[data-ng-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ng-slide]'));
    if(!track || slides.length === 0) return;

    var showArrows = root.getAttribute('data-show-arrows') === 'true';
    var showDots   = root.getAttribute('data-show-dots')   === 'true';
    var autoplay   = root.getAttribute('data-autoplay')    === 'true';
    var loop       = root.getAttribute('data-loop')        === 'true';
    var interval   = parseInt(root.getAttribute('data-interval'), 10);
    if(!(interval > 0)) interval = 5000;

    var btnPrev = root.querySelector('[data-ng-prev]');
    var btnNext = root.querySelector('[data-ng-next]');
    var dotsWrap = root.querySelector('[data-ng-dots]');
    var dots = [];
    var index = 0, timer = null, isPointerDown = false, startX = 0, deltaX = 0;

    if (showDots && dotsWrap) {
      dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-ng-dot]'));
      dots.forEach(function(dot, i){ dot.addEventListener('click', function(){ goTo(i); }); });
    }

    function update(){
      track.style.transform = 'translateX(' + (-index*100) + '%)';
      slides.forEach(function(slide, i){ slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false'); });
      if (dots.length) {
        dots.forEach(function(dot, i){
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          dot.style.opacity = (i === index ? '1' : '0.5');
        });
      }
      if (btnPrev && btnNext && !loop) {
        btnPrev.disabled = index === 0;
        btnNext.disabled = index === slides.length - 1;
      }
    }

    function goTo(i){
      if (i < 0) i = loop ? slides.length - 1 : 0;
      if (i > slides.length - 1) i = loop ? 0 : slides.length - 1;
      index = i; update();
    }
    function next(){ goTo(index + 1); }
    function prev(){ goTo(index - 1); }

    if (showArrows) {
      if (btnPrev) btnPrev.addEventListener('click', prev);
      if (btnNext) btnNext.addEventListener('click', next);
    }

    function start(){ if (autoplay && slides.length > 1) { stop(); timer = setInterval(next, interval); } }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('focusin',  stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusout',  start);

    track.addEventListener('pointerdown', function(e){
      isPointerDown = true; startX = e.clientX; deltaX = 0; stop(); track.style.transitionDuration = '0ms';
    });
    window.addEventListener('pointerup', function(){
      if(!isPointerDown) return;
      isPointerDown = false; track.style.transitionDuration = '';
      if (Math.abs(deltaX) > 50) { (deltaX < 0) ? next() : prev(); } else { update(); }
      start();
    });
    window.addEventListener('pointermove', function(e){
      if(!isPointerDown) return;
      deltaX = e.clientX - startX;
      var dx = (-index*100) + (deltaX / root.clientWidth * 100);
      track.style.transform = 'translateX(' + dx + '%)';
    });

    track.style.width = (slides.length * 100) + '%';
    slides.forEach(function(slide){ slide.style.width = (100 / slides.length) + '%'; });

    update(); start();
  }

  function initAll(){ document.querySelectorAll('[data-ng-testimonials]').forEach(initTestimonials); }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); }
  else { initAll(); }

  document.addEventListener('shopify:section:load', function(e){
    var el = e.target && e.target.querySelector('[data-ng-testimonials]');
    if (el) initTestimonials(el);
  });
})();
/* ====== FORCE ENGLISH NATIVE VALIDATION MESSAGES ====== */
(function () {
  var MSG = {
    valueMissing: 'Please fill out this field.',
    typeMismatchEmail: 'Please enter a valid email address.',
    typeMismatchUrl: 'Please enter a valid URL.',
    badInput: 'Please enter a number.',
    patternMismatch: 'Please match the requested format.',
    tooShort: 'Please lengthen this text.',
    tooLong: 'Please shorten this text.',
    rangeUnderflow: 'Value is too low.',
    rangeOverflow: 'Value is too high.',
    stepMismatch: 'Please enter a valid value.'
  };

  function messageFor(el){
    var v = el.validity;
    if (v.valueMissing) return MSG.valueMissing;
    if (v.typeMismatch && el.type === 'email') return MSG.typeMismatchEmail;
    if (v.typeMismatch && el.type === 'url') return MSG.typeMismatchUrl;
    if (v.badInput) return MSG.badInput;
    if (v.patternMismatch) return MSG.patternMismatch;
    if (v.tooShort) return MSG.tooShort;
    if (v.tooLong) return MSG.tooLong;
    if (v.rangeUnderflow) return MSG.rangeUnderflow;
    if (v.rangeOverflow) return MSG.rangeOverflow;
    if (v.stepMismatch) return MSG.stepMismatch;
    return '';
  }

  // clear custom message on input/change
  document.addEventListener('input', function(e){
    var el = e.target;
    if (el && typeof el.setCustomValidity === 'function') el.setCustomValidity('');
  }, true);

  // set English text when the field fails validation
  document.addEventListener('invalid', function(e){
    var el = e.target;
    if (el && typeof el.setCustomValidity === 'function') {
      el.setCustomValidity(messageFor(el));
    }
  }, true);

  // also when user blurs the field
  document.addEventListener('blur', function(e){
    var el = e.target;
    if (el && el.willValidate && !el.checkValidity()) {
      el.setCustomValidity(messageFor(el));
    }
  }, true);
})();
/* ====== EN VALIDATION MESSAGES + DATE LOCALE ====== */
(function(){
  function applyEnglishValidation(scope){
    var root = scope || document;

    // 1) Английские сообщения для required/invalid
    root.querySelectorAll('input[required], textarea[required], select[required]').forEach(function(el){
      // Сбрасываем и задаём своё сообщение
      el.addEventListener('invalid', function(){
        el.setCustomValidity('');
        if (el.validity.valueMissing) {
          el.setCustomValidity('Please fill out this field.');
        } else if (el.validity.typeMismatch && el.type === 'email') {
          el.setCustomValidity('Please enter a valid email address.');
        } else if (el.validity.patternMismatch) {
          el.setCustomValidity('Please match the requested format.');
        }
      });
      // При вводе очищаем сообщение
      el.addEventListener('input', function(){ el.setCustomValidity(''); });
      el.addEventListener('change', function(){ el.setCustomValidity(''); });
    });

    // 2) Дата — принудительно на английском
    root.querySelectorAll('input[type="date"]').forEach(function(d){
      // Большинство браузеров ориентируются на lang элемента
      d.setAttribute('lang','en-US');
      // Фолбэк-подсказка (если браузер показывает placeholder)
      d.setAttribute('placeholder', 'MM/DD/YYYY');
      // Если поле обязательное — своё сообщение
      d.addEventListener('invalid', function(){
        if (d.validity.valueMissing) d.setCustomValidity('Please choose a date.');
      });
      d.addEventListener('input', function(){ d.setCustomValidity(''); });
      d.addEventListener('change', function(){ d.setCustomValidity(''); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ applyEnglishValidation(); });
  } else {
    applyEnglishValidation();
  }
  // Для перезагрузок секций в редакторе Shopify
  document.addEventListener('shopify:section:load', function(e){
    applyEnglishValidation(e.target || document);
  });
})();
